module.exports = __webpack_public_path__ + "static/media/instant-message-received.abee1b60.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/instant-message-received.mp3
// module id = 1119
// module chunks = 0